import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  FiltroSeparador,
  BotonActualizar,
  KpiRow,
  DashCard,
  ChartBox,
  BarRow,
  EmptyState,
  montarGraficas,
  graficaBarras,
  fmtMoneda,
  fmtNumero,
  pctDe,
  PALETTE,
} from "./dashboardUI";

function DashboardTiendas() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [graficasArea, setGraficasArea] = useState([]);
  const [clientes, setClientes] = useState([]); 
  const [selectedCliente, setSelectedCliente] = useState("");
  const [vendedores, setVendedores] = useState([]); 
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [areas, setAreas] = useState([]); 
  const [selectedArea, setSelectedArea] = useState("");
 
  const [info, setInfo] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [totalVenta, setTotalVenta] = useState(0);
  const [totalAbonos, setTotalAbonos] = useState(0);



  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }
  
  useEffect(() => {
    axios
      .get(`${URL_DASHBOARDS}Tiendas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGraficas = response.data;
        setInfo(allGraficas);

        let TTot = allGraficas.map((c) => parseFloat(c.Ventas));
        let TT = TTot.reduce((t, total, index) => t + total, 0);
        setTotalVenta(TT);
    
        let TAbo = allGraficas.map((c) => parseFloat(c.Abonos));
        let TA = TAbo.reduce((t, total, index) => t + total, 0);
        setTotalAbonos(TA);

        let unicosCli = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idCliente === value.idCliente)
        );
        setClientes(unicosCli);

        let unicosAre = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArea === value.idArea)
        );
        setAreas(unicosAre);

        let unicosVend = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idVendedor === value.idVendedor)
        );
        setVendedores(unicosVend);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  function BuscaInfo(){
    setInfo([])
    setSelectedCliente("")
    setSelectedArea("")
    setSelectedVendedor("")
    setCargando(true)
    axios
      .get(`${URL_DASHBOARDS}Tiendas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGraficas = response.data;
        setInfo(allGraficas);

        let TTot = allGraficas.map((c) => parseFloat(c.Ventas));
        let TT = TTot.reduce((t, total, index) => t + total, 0);
        setTotalVenta(TT);
    
        let TAbo = allGraficas.map((c) => parseFloat(c.Abonos));
        let TA = TAbo.reduce((t, total, index) => t + total, 0);
        setTotalAbonos(TA);

        let unicosCli = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idCliente === value.idCliente)
        );
        setClientes(unicosCli);

        let unicosVend = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idVendedor === value.idVendedor)
        );
        setVendedores(unicosVend);

        let unicosAre = allGraficas.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArea === value.idArea)
        );
        setAreas(unicosAre);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });

  }

  useMemo(()=>{
    let temp = info
    if (selectedCliente) {
      temp = temp.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedArea) {
      temp = temp.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }

    if (selectedVendedor) {
      temp = temp.filter((e) =>
        e.idVendedor.includes(selectedVendedor)
      );
    }

    let agrupadoArea = temp.reduce(function (groups, item) {
      const val = item["idArea"] 
      groups[val] = groups[val] || {
        idArea: item.idArea,
        Ventas: 0,
        Abonos: 0,

      };
      groups[val].Ventas += item.Ventas;
      groups[val].Abonos += item.Abonos;
      groups[val].Area = item.Area;
      groups[val].idArea = item.idArea;
      return groups;
    }, []);

    let otraArea = Object.values(agrupadoArea).sort((a, b) =>
    a.Ventas < b.Ventas ? 1 : -1
  );

    setGraficasArea(otraArea)


    let TTot = temp.map((c) => parseFloat(c.Ventas));
    let TT = TTot.reduce((t, total, index) => t + total, 0);
    setTotalVenta(TT);

    let TAbo = temp.map((c) => parseFloat(c.Abonos));
    let TA = TAbo.reduce((t, total, index) => t + total, 0);
    setTotalAbonos(TA);



  },[info, selectedCliente, selectedVendedor, selectedArea])

  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdiv", (root) => graficaBarras(root, {
          data: graficasArea, categoria: "Area",
          series: [
            { valor: "Ventas", nombre: "Ventas", color: "#3b82f6" },
            { valor: "Abonos", nombre: "Abonos", color: "#10b981" },
          ],
          moneda: true, exportar: true, archivo: "Tiendas_Ventas_Abonos",
        })],
      ]),
    [graficasArea]
  );

  const kpis = [
    { label: "Total venta", value: totalVenta, formato: "moneda", icon: "fas fa-cash-register", color: "#3b82f6" },
    { label: "Total abonos", value: totalAbonos, formato: "moneda", icon: "fas fa-hand-holding-usd", color: "#10b981", pct: pctDe(totalAbonos, totalVenta), sub: `${fmtNumero(pctDe(totalAbonos, totalVenta), 1)}% de la venta` },
    { label: "Tiendas", value: graficasArea.length, formato: "entero", icon: "fas fa-store", color: "#ec4899" },
  ];

  const maxVenta = Math.max(...graficasArea.map((a) => Math.abs(parseFloat(a.Ventas) || 0)), 1);

  return (
    <>
      <Header />
      {/* {user.menu_reportes ? ( */}
      <DashPage
        icon="fas fa-store"
        color="#ec4899"
        bg="#fdf2f8"
        title="Dashboard Tiendas"
        subtitle="Ventas y abonos del punto de venta por tienda"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Fecha inicio" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
              }}
            />
          </Filtro>
          <Filtro label="Fecha fin" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
              }}
            />
          </Filtro>
          <BotonActualizar onClick={BuscaInfo} cargando={cargando} />

          <FiltroSeparador />

          <Filtro label="Cliente">
            <Input
              bsSize="sm"
              type="select"
              value={selectedCliente}
              onChange={(e) => {
                setSelectedCliente(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {clientes
                .sort((a, b) => (a.Cliente > b.Cliente ? 1 : -1))
                .map((a) => {
                  return <option key={a.idCliente} value={a.idCliente}>{a.Cliente}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Vendedor">
            <Input
              bsSize="sm"
              type="select"
              value={selectedVendedor}
              onChange={(e) => {
                setSelectedVendedor(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {vendedores
                .sort((a, b) => (a.Vendedor > b.Vendedor ? 1 : -1))
                .map((a) => {
                  return <option key={a.idVendedor} value={a.idVendedor}>{a.Vendedor}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Almacén">
            <Input
              bsSize="sm"
              type="select"
              value={selectedArea}
              onChange={(e) => {
                setSelectedArea(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {areas
                .sort((a, b) => (a.Area > b.Area ? 1 : -1))
                .map((a) => {
                  return <option key={a.idArea} value={a.idArea}>{a.Area}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col lg={8}>
            <DashCard icon="fas fa-chart-bar" color="#3b82f6" title="Ventas y abonos por tienda" subtitle="Importe del período">
              <ChartBox id="chartdiv" height={360} cargando={cargando} vacio={graficasArea.length === 0} />
            </DashCard>
          </Col>
          <Col lg={4}>
            <DashCard icon="fas fa-trophy" color="#f59e0b" title="Ranking de tiendas" subtitle="Ordenadas por venta">
              {!cargando && graficasArea.length === 0 ? (
                <EmptyState />
              ) : (
                <div style={{ maxHeight: 360, overflowY: "auto", paddingRight: 4 }}>
                  {graficasArea.map((a, i) => (
                    <BarRow
                      key={a.idArea || i}
                      label={a.Area}
                      value={fmtMoneda(a.Ventas)}
                      pct={(Math.abs(parseFloat(a.Ventas) || 0) / maxVenta) * 100}
                      color={PALETTE[i % PALETTE.length]}
                      sub={`Abonos ${fmtMoneda(a.Abonos)}`}
                    />
                  ))}
                </div>
              )}
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/*  ) : undefined} */}
    </>
  );
}
export default DashboardTiendas;
